import { render, staticRenderFns } from "./LeaveModal.vue?vue&type=template&id=2a1402a0&lang=pug&functional=true"
import script from "./LeaveModal.vue?vue&type=script&lang=js"
export * from "./LeaveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports